import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDxTq_vAnYSTLoo6YjBl1DYC1vj6gZwrKU",
  authDomain: "loghook-a1429.firebaseapp.com",
  projectId: "loghook-a1429",
  storageBucket: "loghook-a1429.firebasestorage.app",
  messagingSenderId: "536803618348",
  appId: "1:536803618348:web:ef9e79e8fa8ad87fc5eb89",
  measurementId: "G-X87QX7R3MP",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
